<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <div
                    class="sections-wrapper contact-wrapper"
                    style="visibility: inherit; opacity: 1;"
                  >
                    <section
                      class="wysiwyg-block-component bg-layer  phone_block-layout"
                      style="z-index: 5;"
                    >
                      <div class="wysiwyg-wrapper grid-wrapper">
                        <div class="grid-12 pad-mb sm-grid-8 md-grid-7">
                          <div class="content-wrapper">
                            <h3
                              class="subtitle-component little uppercase mov"
                              :class="{'active': show}"
                            >
                              加盟代理
                            </h3>
                          </div>
                          <div class="content-wrapper">
                            <div
                              class="content-component wysiwyg-layout default mov"
                              :class="{'active': show}"
                            >
                              <p>
                                很乐意为您解答关于赢裳恩加盟代理的相关问题，请通过以下表格与我们联系。
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      class="phone-block-component bg-layer form_block-layout"
                      style="z-index: 4;"
                    >
                      <div
                        class="phone-wrapper grid-wrapper"
                        style="opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);"
                      >
                        <div
                          class="grid-12 pad-mb sm-grid-8 md-grid-7 phone-layout"
                        >
                          <p class="content-component default mov" :class="{'active': show}">上海市闵行区莲花路1308号A座301-302<br>
邮编：200233<br>
电话：021-5117 0687<br>
传真：021-5117 0677</p>
                        </div>
                      </div>
                    </section>
                    <section class="form-block-component text_block-layout">
                      <div class="form-wrapper grid-wrapper">
                        <div class="grid-12 pad-mb sm-grid-8 md-grid-7">
                          <div
                            class="dropdown grid-12 sm-grid-6 sm-pad-1-right mov"
                            :class="{'active': show}"
                          >
                            <p class="content-component default" >主题 * (必填)</p>
                            <div class="select-container-component">
                              <Select v-model="theme">
                                  <Option
                                    v-for="item in cityList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.value }}</Option
                                  >
                                </Select>
                            </div>
                          </div>
                          <div
                            class="form-container grid-12 mov"
                            :class="{'active': show}"
                          >
                            <div class="grid-12 sm-grid-6 sm-pad-1-right">
                              <p class="content-component default" >姓名 * (必填)</p>
                              <input
                                type="text"
                                v-model="name"
                                maxlength="100"
                                placeholder="您的名字"
                              />
                            </div>
                            <div
                              class="grid-12 sm-grid-6 sm-pad-1-left mov"
                              :class="{'active': show}"
                            >
                              <p class="content-component default" >邮箱 * (必填)</p>
                              <input
                                type="email"
                                maxlength="100"
                                v-model="email"
                                placeholder="您的邮箱"
                              />
                            </div>
                          </div>
                          <div
                            class="form-container grid-12 mov"
                            :class="{'active': show}"
                          >
                            <div class="grid-12">
                              <p class="content-component default" >讯息</p>
                              <textarea
                                type="text"
                                placeholder="具体信息"
                                 v-model="content"
                              ></textarea>
                            </div>
                          </div>
                          <div class="btn-container">
                            <div
                              class="button-component grey"
                              :class="{'active': show}"
                            >
                              <div class="link-container" @click="sendFn"><p>发送</p></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import {Select,Option} from 'view-design';
import 'view-design/dist/styles/iview.css';
export default {
  name: "locator",
  data() {
    return {
      list: [],
      copyList: [],
      activeIndex: 0,
      show: false,
      cityList: [
        {
          value: "加盟代理",
          label: "加盟代理"
        },
      ],
       theme: "",
      name: '',
      email: '',
      content: ''
    }
  },
  mounted() {
    this.show = true
  },
  components: {
    Header,
    Footer,
    Select,
    Option
  },
  methods: {
    async sendFn() {
      if(!this.theme || !this.email || !this.name) {
        this.$Message.error('请填写必填项！');
      } else {
        let {data} = await axios.post(
          "/Api/SendMail_Join",
          {
            subject: this.theme,
            body: `姓名：${this.name}<br>邮箱：${this.email}<br>讯息：${this.content}`
          }
        );
        if(data.errcode == 0){
          this.$Message.success('感谢! 您的反馈已发送，我们将尽快为您提供答复。');
        } else {
          this.$Message.error(data.errmsg);
        }
      }
    }
  }
};
</script>

<style scoped>
/deep/.ivu-select-selection{
      z-index: 10;
    border: 1px solid #cdc4b8;
    position: relative;
    padding: 5px 0 6px 20px;
    height: auto!important;
    border-radius: 0;
    text-align: left;
    cursor: pointer;
    background: 0 0;
}
/deep/.ivu-select-item, /deep/.ivu-select{
  color: rgb(95, 79, 70);
}
/deep/.ivu-select-dropdown{
  background: #f6f4f0;
  color: rgb(95, 79, 70);
}
/deep/.ivu-select-item:hover{
  background: #eeebe5;
}
/deep/.ivu-select-item-selected, /deep/.ivu-select-item-selected:hover{
  color: rgb(95, 79, 70);
}
.mov.active{
  opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);
}
.mov{
  opacity: 0;transform: translate(0%, 100%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}
</style>